function initAllSelects() {
  const selects = document.querySelectorAll('select:not([data-select2-initialized])');

  selects.forEach(select => {
    const defaultOptions = Array.from(select.querySelectorAll('option')).map(option => ({
      id: option.value,
      text: option.innerHTML // <-- Giữ nguyên HTML trong option
    }));

    $(select).select2({
      width: '100%',
      dropdownParent: $(select).parent(),
      data: defaultOptions,
      escapeMarkup: function (markup) {
        return markup; // Đừng escape HTML
      },
      templateResult: function (data) {
        return data.text; // Hiển thị dropdown với HTML
      },
      templateSelection: function (data) {
        return data.text; // Hiển thị text được chọn với HTML
      }
    });

    select.dataset.select2Initialized = 'true';
  });
}

$(document).ready(initAllSelects);
